import { useState } from "react";
import StepRefundMethod from "../your_order/StepRefundMethod";
import StepCancelReason from "../your_order/StepCancelConfirmation";
import FinalConfirmation from "../your_order/CancelConfirmation";

const CancelSteps = ({
  setIsCancel,
  orderID,
  orderData,
  refetch,
  setOpenOrder,
}) => {
  const [step, setStep] = useState(1);
  const [cancelReason, setCancelReason] = useState(null);
  const [additionalComments, setAdditionalComments] = useState("");
  const [refundMethod, setRefundMethod] = useState("");

  const handleNext = () => setStep((prev) => prev + 1);
  const handleBack = () => setStep((prev) => prev - 1);
  return (
    <div className="max-w-[800px] mx-auto">
      {step === 1 && (
        <StepCancelReason
          onNext={handleNext}
          cancelReason={cancelReason}
          setCancelReason={setCancelReason}
          additionalComments={additionalComments}
          setAdditionalComments={setAdditionalComments}
          setIsCancel={setIsCancel}
          orderID={orderID}
          orderData={orderData}
          setStep={setStep}
        />
      )}

      {step === 2 && (
        <StepRefundMethod
          onNext={handleNext}
          refundMethod={refundMethod}
          setRefundMethod={setRefundMethod}
          cancelReason={cancelReason}
          additionalComments={additionalComments}
          onBack={handleBack}
          orderData={orderData}
          orderID={orderID}
          setStep={setStep}
        />
      )}

      {step === 3 && (
        <FinalConfirmation
          setClose={setIsCancel}
          type={"Cancellation"}
          refetch={refetch}
          setOpenOrder={setOpenOrder}
        />
      )}
    </div>
  );
};
export default CancelSteps;
